import { useRouteError } from 'react-router-dom';
import { ErrorState } from '../components/states';

export function RouteError() {
  const error = useRouteError();
  const message = error instanceof Error ? error.message : 'Unexpected routing error.';

  return (
    <main className="workspace-main">
      <ErrorState
        title="Page failed to load"
        detail={message}
        onRetry={() => window.location.reload()}
      />
    </main>
  );
}
